<template>
  <div>
     <div class="header">
       <div class="header-bar">
         <div class="head-title" :style="this.$route.path.indexOf('dashboard')==-1 && this.$route.path.indexOf('center')==-1?'justify-content:space-between':''">
           <div class="menu-wrap" v-if="this.$route.path.indexOf('dashboard')!==-1 || this.$route.path.indexOf('center')!==-1 ">
            <div class="forecast-logo" @click="goDashboard">
             <img src="./images/logo.png" alt="">
            </div>
            <div class="menu" v-if="version !== 'procuratorate'">
              <router-link :to="{path:'/forecast/dashboard'}">
                <span>智能量刑辅助系统</span>
              </router-link>
            </div>
            <div class="menu" v-if="version !== 'procuratorate'">
              <span @click="goTarget('law')">刑事法律法规</span>
            </div>
            <div class="menu" v-if="version !== 'procuratorate'">
              <span @click="goTarget('case')">案例检索</span>
            </div>
            <div class="menu" style="cursor:pointer" v-if="version !== 'procuratorate'">
              <el-dropdown trigger="hover">
                <span class="el-dropdown-link" style="color:#fff;">
                  检察文书
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <div>
                      <el-tooltip effect="dark"  placement="right-start" content="产品开发中">
                        <a>起诉书</a>
                      </el-tooltip>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item>
                    <div>
                      <el-tooltip effect="dark"  placement="right-start" content="产品开发中">
                        <a>不起诉决定书</a>
                      </el-tooltip>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
           </div> 
           <div v-else>
             <div class="back" @click="goBack()" v-if="version !== 'procuratorate' || this.$route.path.indexOf('home')==-1">
              <i class="el-icon-arrow-left"></i>
              返回
             </div>
              <div class="back" v-else>
                <router-link to="/forecast/dashboard" style="color:#fff">
                  <span>小包公智能量刑辅助系统</span>
                </router-link>
              </div>
           </div>    

          <div class="user" v-if="userInfo.name && version !== 'procuratorate'">
           <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                <span class="icon-small" style="margin-bottom:4px;"><img src="./images/login.png" alt=""></span>
                <span style="color:#fff">{{userInfo.name}}</span>
              </span>
              <el-dropdown-menu slot="dropdown" v-if="!isThird">
                <el-dropdown-item>
                  <div @click="goCenter"><a>个人中心</a></div>
                </el-dropdown-item>
                <el-dropdown-item v-if="!projectInfoConfig.hideLogout">
                  <div class="out" @click="loginOut"><a>退出登录</a></div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
           </div>
           <div v-if="!userInfo.name && version !== 'procuratorate'" class="login-bar" @click="openDialog">
               <span>登录</span>
           </div>
         </div>
       </div>
     </div>
     <div class="top-contrainer" v-if="!this.$route.query.export_token">
        <div class="main-header">
            <div class="left-header">
                <div class="layout-header-system">
                  <template v-if="$route.path !== '/forecast/dashboard'">
                    <router-link to="/forecast/dashboard" v-if="$route.path === '/forecast/report-list'">
                      <div class="layout-header-system-back-btn pagejump">
                        <i class="el-icon-arrow-left"></i>
                        <span>首页</span>
                      </div>
                    </router-link>
                    <div class="layout-header-system-back-btn pagejump" @click="goBack" v-else>
                      <i class="el-icon-arrow-left"></i>
                      <span>{{ backTextTmp || '返回' }}</span>
                    </div>
                  </template>
                  <img v-if="projectInfoConfig.fullLogo" class="layout-header-system-logo" :src="projectInfoConfig.fullLogo" @click="goStaticHome">
                  <span class="layout-header-system-label">智能量刑预测</span>
                </div>
            </div>
            <div class="right-header">
              <div class="system-expired-info" v-if="!isThird && $route.name === 'forecastDashboard' && forecastSurplus > 0">
                <div class="vip-free-surplus">
                  <span>剩余可用次数：{{ forecastSurplus }}次</span>
                  <div class="vip-free-surplus-btn" @click="$store.commit('setBuyVip',true)">立即购买</div>
                </div>
              </div>
              <el-dropdown trigger="click" v-if="userInfo.tel">
                <span class="el-dropdown-link">
                  <span class="icon-middle" style="width:30px;margin-right: 10px;">
                    <img src="../../assets/default-icon.png" alt="">
                  </span>
                  {{userInfo.tel | phone-filter}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>
                    <div class="header-portrait">
                      <div class="icon-middle" style="width:30px;margin-left:-5px;margin-right: 10px;">
                        <img src="../../assets/default-icon.png" alt="">
                      </div>
                      <div>
                        <p>{{userInfo.tel | phone-filter}}</p>
                      </div>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="!isThird && userInfo.role!=='OM' && userInfo.role!=='SA' && productList.length>0">
                    <div class="open-vip" @click="openBuyVip">
                      <div>
                        <p class="word-normal">小包公VIP</p>
                        <span class="word-smaller">享受产品特权服务</span>
                      </div>
                      <div class="btn word-smaller">开通VIP</div>
                    </div>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="!isThird">
                    <div class="user-dropdown">
                     <router-link :to="'/forecast/center'">个人中心</router-link>
                    </div>
                  </el-dropdown-item>
                   <el-dropdown-item>
                    <div class="user-dropdown">
                      <router-link :to="'/forecast/report-list'">刑期报告</router-link>
                    </div>
                  </el-dropdown-item>
                   <el-dropdown-item v-if="!isThird && !projectInfoConfig.hideLogout">
                    <div class="user-dropdown" @click="loginOutHome">
                     <a>退出</a>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <div v-else>
                <a @click="showLogin = true">登录</a>
                <el-button @click="showRegister = true" type="primary">注册</el-button>
              </div>  
            </div>
        </div>
     </div>
     <router-view ref="home" @changeBackText="text => (backTextTmp = text)"></router-view>

     <el-dialog width="360px" custom-class="memberDialog" :visible.sync="perssion" title="登录" @close="closeDialog" :close-on-click-modal="false">
       <div style="margin-top: 30px;">
          <div class="form">
              <p class="form-label">用户名</p>
              <el-input v-model="model.name" type="text" placeholder="请输入用户名"></el-input>
          </div>
          <div class="form">
              <p class="form-label">密码</p>
              <el-input v-model="model.password" type="password" placeholder="请输入密码"></el-input>
          </div>
          <div class="form">
            <el-checkbox v-model="remember">记住密码</el-checkbox>
          </div>
          <div style="margin-top:22px;">
              <el-button style="width:100%;background:@mainColor" @click="loginEvent" type="primary">登录</el-button>
          </div>
       </div>
     </el-dialog>

     <el-dialog width="500px" custom-class="freeDialog" :visible.sync="freeTime" :show-close="false" :close-on-click-modal="false">
       <div class="code-panel">
         <h4>免费试用已结束</h4>
         <p class="if word-middle">如需继续使用系统，请购买许可证密钥。</p>
         <div class="code-bar">
           <p>如果你已经购买了许可证密钥，请输入 License Key</p>
           <el-input v-model="secretKey" type="text" placeholder="xxxx-xxxx-xxxx-xxxx"></el-input>
           <div style="text-align:right;margin-top:10px;">
             <el-button style="width:120px;" type="primary" @click="activationEvent">激活</el-button>
           </div>
         </div>
       </div>
     </el-dialog>

     <el-dialog width="700px" custom-class="buyVipDialog" :visible="buyVip && productList.length>0 && !isThird" :show-close="true" :close-on-click-modal="true" @close="closeDialog">
       <div class="buy-panel">
          <div class="buy-panel-top">
            <div class="header-portrait">
              <div style="margin: 0 10px 10px 10px">
                <span style="width:32px;" class="icon-big"><img src="../../assets/default-icon-64.png" alt=""></span>
              </div>
              <div class="tel">
                <p>{{userInfo.tel}}</p>
              </div>
            </div>
          </div>
          <div class="buy-panel-body">
            <div class="buy-panel-left">
              <ul>
                <li @click="choicePro(item)" :class="activeBuy==item.name?'cur':''" v-for="(item,index) in productList" :key="index">
                  <span class="vip-list-icon">
                    <img src="../../assets/vip-list.png" alt="">
                    <img src="../../assets/vip-list-gray.png" alt="">
                  </span>
                  <a>{{item.name}}</a>
                </li>
              </ul>
            </div>
            <div class="buy-panel-right">
              <h4>{{productModel.name}}VIP套餐</h4>
              <div style="display:flex">
                <div v-for="(col,idx) in productModel.subItem" :key="idx" class="sub-pro" @click="choiceWay(col,idx)" :class="activeWay == idx?'cur':''">
                  <p v-if="col.productList[0].chargeType == 'month'">{{col.productList[0].chargeCycle}}个月</p>
                  <p v-else>{{col.productList[0].chargeCycle}}次</p>
                  <span>¥{{col.payPrince}}</span>
                  <span style="font-size: 12px; color: #fff;" v-if="col.couponDiscountPrice">预估折后到手：￥{{ col.couponDiscountPrice }}</span>
                  <s v-else>原价{{col.firstPrince}}</s>
                </div>
              </div>

              <div class="vip-tip">
                <div v-if="productModel.descHtml" v-html="productModel.descHtml"></div>
                <template v-else>
                  <p>VIP特权</p>
                  <span class="word-normal">{{productModel.desc}}</span>
                </template>
              </div>

              <div class="pay-panel">
                <div id="qrcode" ref="qrcode"></div>
                <div style="margin-left:20px;">
                  <div style="color:#222;font-size:16px;margin-bottom:10px;">应付金额</div>
                    <div>
                      <span style="color:#E42626;font-size:28px;font-weight:bold">
                        ¥{{way.couponDiscountPrice || way.discountPrince}}
                      </span>
                      <span v-if="couponEntities.length > 0" class="coupon-card-desc">
                        <span>已使用</span>
                        <span>{{ couponEntities | couponFilter }}</span>
                        <span>折卡</span>
                      </span>
                      <s style="color:#999;" class="word-normal" v-else-if="way.firstPrince">
                        原价{{way.firstPrince}}元
                      </s>
                    </div>
                    <div style="margin-top:27px;">
                      <span class="wechat-pay"><img src="../../assets/wechat-pay.png" alt=""></span>
                      <span>使用微信扫码支付</span>
                    </div>
                </div>
              </div>
            </div>
          </div>
       </div>
     </el-dialog>

    <vipCreator
      v-if="expiredModalShow"
      :show.sync="expiredModalShow"
      limitType="forecast"
      vipType="forecast"
    />
  </div>
</template>

<script>
import Home from '@/views/forecast/home' 
import QRCode from "qrcodejs2";
import { mapGetters } from 'vuex'
import { services } from "@/service";
import { projectInfoConfig } from '@/constant';
import vipCreator from '@/components/vipCreator';
export default {
  data () {
    return {
      projectInfoConfig,
      model: {
        tel: "",
        name: "",
        password: ""
      },
      version: window.version,
      userInfo:{},
      remember: true,
      secretKey: "",
      productList:[],
      activeBuy: '',
      productModel: {},
      activeWay: '',
      way: {},
      orderId: "",
      payTimeOut:"",
      backTextTmp: '',
      couponEntities: [],
      expiredModalShow: false
    };
  },

  components: { Home, vipCreator},
  computed:{
    ...mapGetters([
      'perssion',
      'freeTime',
      'buyVip',
      'forecastSurplus',
      'isThird'
    ]),
  },
  filters: {
    couponFilter(couponEntities) {
      return couponEntities[0].discount;
    }
  },
  watch:{
    "remember":function(val){
      if(!val){
        localStorage.removeItem('loginInfo')
      }
    },
    'buyVip':function(val){
      if(!val && this.payTimeOut){
        clearInterval(this.payTimeOut)
      }
      if(val){
        if (this.isThird) {
          this.closeDialog();
          this.expiredModalShow = true;
        } else {
          this.choiceWay(this.productModel.subItem[0],0);
        }
      }
    },
    $route() {
      this.backTextTmp = '';
      if (this.$route.name === 'forecastDashboard') {
        this.$store.dispatch('refreshForecastVip');
      }
    }
  },

  mounted(){
    this.$store.dispatch('refreshForecastVip');
    this.$store.state.loading = false
    if (localStorage.getItem('token')) {
      this.userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    } else {
      localStorage.removeItem('userInfo');
    }
    let infoStr = window.localStorage.getItem('loginInfo');
    if(infoStr){
       this.model.name = decodeURIComponent(JSON.parse(infoStr).name);
       this.model.password = decodeURIComponent(JSON.parse(infoStr).password);
    }
    var that = this
    document.onkeydown =function(e){
      e = window.event || e;
      if(that.perssion && (e.code=='Enter'||e.code=='enter')){//验证在登录界面和按得键是回车键enter
        that.loginEvent();//登录函数
      }
    }
    this.refreshProductList();
  },

  methods: {
    refreshProductList() {
      if(this.userInfo.tel){
        this.httpGet('user/products?purpose=PC').then((data)=>{
          if(data && data.statusCode == 1){
            // this.productList = data.data;
            const productList = [];
            data.data.forEach(v=>{
              var find = _.find(productList,{name:v.name});
              if(!find){
                v.subItem = []
                v.subItem.push({
                  id: v.id,
                  name:v.name,
                  desc: v.desc,
                  descHtml: v.descHtml,
                  chargeCycle: v.chargeCycle,
                  chargeType: v.chargeType,
                  payPrince: v.payPrince,
                  discountPrince: v.discountPrince,
                  productList: v.productList,
                  firstPrince: v.firstPrince,
                  userType: v.userType,
                  couponDiscountPrice: v.couponDiscountPrice
                })
                productList.push(v)
              }else{
                find.subItem.push({
                  id: v.id,
                  name:v.name,
                  desc: v.desc,
                  descHtml: v.descHtml,
                  chargeCycle: v.chargeCycle,
                  chargeType: v.chargeType,
                  payPrince: v.payPrince,
                  discountPrince: v.discountPrince,
                  productList: v.productList,
                  firstPrince: v.firstPrince,
                  userType: v.userType,
                  couponDiscountPrice: v.couponDiscountPrice
                })
              }
            })
            this.productList = productList;
            if(data.data.length>0){
              this.activeBuy = data.data[0].name;
              this.productModel = data.data[0];  
            }   
          }
        })
      }
    },
    goDashboard(){
      this.$router.push({
        path: '/forecast/dashboard'
      })
    },
    goStaticHome(){
      if (this.isThird) {
        return;
      }
      var locationHref = window.location.href;
      location.href = locationHref.slice(0, locationHref.indexOf('/home.html')) + '/index.html'
    },
    loginOutHome(){
      this.httpGet('admin/logout').then((data)=>{
        sessionStorage.removeItem('token');
        sessionStorage.removeItem("_TOKEN_");
        localStorage.removeItem('token');
        localStorage.removeItem('userInfo')
        localStorage.removeItem('timeToken');
        sessionStorage.removeItem('userInfo');
        this.userInfo = {}
        this.goStaticHome()
      })
    
    },
    closeDialog(){
      this.$store.commit('setBuyVip',false)
    },
    openBuyVip(){
      if(this.productModel.subItem && this.productModel.subItem.length>0){
        //  this.choiceWay(this.productModel.subItem[0],0);
         this.$store.commit("setBuyVip",true)
      }else{
        this.$message({
            message: '获取产品失败，请稍后再试',
            type: "warning"
        })
      }
      
    },
    async qrcode(name,id,discountPrince) {
      const params = {
        productId: id,
        body: `小包公-${name}`,
      };
      const result = await services.vip.createOrder(params);
      if (result.statusCode !== 1) {
        throw new Error(result.message);
      }
      const { orderInfo, unifiedOrder } = result.data;
      new QRCode("qrcode", {
        width: 108,
        height: 108,
        text: unifiedOrder.codeUrl,
      });
      this.orderId = unifiedOrder.orderId;
      this.couponEntities = orderInfo.couponEntities || [];
      clearInterval(this.payTimeOut);
      this.payTimeOut = setInterval(()=>{
        this.getOrderStatus()
      },2000);
    },
    getOrderStatus(){
      this.httpGet(`wechat/order/${this.orderId}`).then((data)=>{
        if(data && data.statusCode == 1){
          if(data.data.status == 'SUCCESS'){
            clearInterval(this.payTimeOut)
            this.$message({
              message: '支付成功',
              type: "success"
            })
            this.$store.commit('setBuyVip',false);
            this.refreshProductList();
            if (this.$route.name === 'forecastDashboard') {
              this.$store.dispatch('refreshForecastVip');
            }
          }
        }
      })
    },
    choicePro(item){
      this.productModel = item
      this.activeBuy = item.name;
      this.choiceWay(this.productModel.subItem[0], 0)
    },
    choiceWay(col,index){
      this.activeWay = index;
      this.way = col;
      this.$nextTick(() => {
        document.getElementById('qrcode').innerHTML = ""
        this.qrcode(col.name,col.id,col.discountPrince);
      });
    },
    activationEvent(){
      let param = {
        secretKey: this.secretKey
      }
      this.httpPost('admin/period',param).then((data)=>{
        if(data && data.statusCode == 1){
          this.$store.commit('setFreeTime',false)
          this.$message({
            message: '激活成功',
            type: "success"
          })
          var that = this
          setTimeout(()=>{
            that.$router.go(0)
          },1000)
        }else{
          this.$message({
            message: data.message,
            type: "warning"
          })
        }
      })
    },
    goTarget(type){
      let token = window.localStorage.getItem("token")
      if(!token){
        this.$message({
          message: '您尚未登录，请先登录再进行操作',
          type: "warning"
        })
        return;
      }

      if(type == 'law'){
        let { href } = this.$router.resolve({
            path: '/law/home'
        })
        window.sessionStorage.removeItem('historyList')
        window.open(href, '_blank')
      }else{
        let { href } = this.$router.resolve({
            path: '/case/search'
        })
        window.open(href, '_blank')
      }
    },
    loginOut(){
      this.httpGet('admin/logout').then((data)=>{
        sessionStorage.removeItem('token');
        sessionStorage.removeItem("_TOKEN_");
        localStorage.removeItem('token');
        sessionStorage.removeItem('userInfo');
        localStorage.removeItem('userInfo');
        this.userInfo = {}
        this.$router.push({
          path: '/forecast/dashboard'
        })
      })
      
    },
    // closeDialog(){
    //   this.$store.commit('setPerssion',false)
    //   this.userInfo = JSON.parse(sessionStorage.getItem('userInfo')) || {}
    // },
    openDialog(){
      this.$store.commit('setPerssion',true)
    },
    loginEvent(){
      if(!this.model.name){
        this.$message({
            message: '请输入用户名',
            type: "warning"
        })
        return;
      }

      if(!this.model.password){
        this.$message({
            message: '请输入密码',
            type: "warning"
        })
        return;
      }

      this.httpGet(`admin/login?name=${encodeURIComponent(this.model.name)}&password=${this.model.password}`).then((data)=>{
        if(data && data.statusCode == 1){
          window.localStorage.setItem('token',data.data);
          sessionStorage.setItem('_TOKEN_',data.data.token);
          window.localStorage.removeItem('loginInfo')
          if(this.model.name && this.model.password){
            let info = {
              name: encodeURIComponent(this.model.name),
              password: encodeURIComponent(this.model.password)
            }
            if(this.remember){
              window.localStorage.setItem('loginInfo',JSON.stringify(info))
            }
          }
          this.httpGet(`admin/user`).then((res)=>{
            if(res && res.statusCode == 1){
              localStorage.setItem('userInfo',JSON.stringify(res.data))
              sessionStorage.setItem('_USER_INFO_',JSON.stringify(res.data));
              this.userInfo = res.data;
              this.$message({
                  message: '登录成功',
                  type: "success"
              })
              this.$router.go(0)
            }else{
              this.$message({
                  message: res.message,
                  type: "warning"
              })
            }
          })
          this.$store.commit('setPerssion',false)
        }else{
          this.$message({
              message: data.message,
              type: "warning"
          })
        }
      })
      
    },
    goBack(){
      if(this.$refs['home'].goback){
        this.$refs['home'].goback()
      }else if(this.$route.path.indexOf('step')!==-1){
        if(this.$route.query.home || window.version == 'procuratorate' || window.version == 'localversion'){
          this.$router.push({
            path: '/forecast/home',
            bookId: sessionStorage.getItem('bookId'),
            city: this.$route.query.city || sessionStorage.getItem('city')
          })
        }else{
          this.$router.push({
            path: '/forecast/dashboard'
          })
        }
      }else if(this.$route.path.indexOf('home')!==-1){
        this.$router.push({
            path: '/forecast/dashboard'
        })
      }else{
        this.$router.go(-1)
      }
    },
    goCenter(){
      this.$router.push({
        path: '/forecast/center'
      })
    }
  },
  destroyed(){
    if(this.payTimeOut){
      clearInterval(this.payTimeOut)
    }
  }
}

</script>
<style scoped lang="less">
.coupon-card-desc {
  position: relative;
  top: -4px;
  color: #fff;
  font-size: 14px;
  line-height: 20px;
  border-radius: 4px;
  background-color: #e47826;
  padding: 4px 8px;
  margin-left: 10px;
}
.system-expired-info {
  display: inline-block;
  margin-right: 30px;

  .vip-time-info {
    display: flex;
    align-items: center;
    height: 24px;

    .vip-time-info-content {
      color: #FEDDA9;
      font-size: 12px;
      height: 24px;
      line-height: 24px;
      background: linear-gradient(270deg, #383E49 0%, #505868 100%);
      border-radius: 2px 0px 0px 2px;
      padding: 0 10px;

      .vip-time-info-img {
        width: 22px;
      }
    }
    .vip-time-info-renew-btn {
      color: #172237;
      font-size: 12px;
      line-height: 24px;
      background: #FEDDA9;
      border-radius: 0px 2px 2px 0px;
      padding: 0 10px;
      cursor: pointer;
    }
  }
  
  .vip-free-surplus {
    display: flex;
    align-items: center;
    color: #4E555B;
    font-size: 14px;
    line-height: 20px;
    cursor: auto;

    .el-icon-question {
      position: relative;
      top: -1px;
      font-size: 16px;
      color: #E6A23C;
      cursor: pointer;
      margin-right: 2px;
    }

    .vip-free-surplus-btn {
      color: #3f6efc;
      font-size: 12px;
      height: 24px;
      line-height: 24px;
      margin-left: 8px;
      border-radius: 2px;
      cursor: pointer;
    }
  }
}
.layout-header-system {
  display: flex;
  align-items: center;
  margin: 0 50px 0 10px;

  .layout-header-system-back-btn {
    height: 32px;
    color: #172237;
    font-size: 14px;
    line-height: 32px;
    background: #F7F7F7;
    border-radius: 0px 100px 100px 0px;
    padding: 0 11px;
    margin-left: -20px;
    margin-right: 10px;
    cursor: pointer;

    .el-icon-arrow-left {
      margin-right: 2px;
    }
  }

  .layout-header-system-logo {
    height: 24px;
    cursor: pointer;
    margin-right: 10px;
  }
  .layout-header-system-label {
    color: #172237;
    font-size: 16px;
    line-height: 24px;
    font-weight: bold;
  }
  .layout-header-system-enterprise {
    color: #3F6EFC;
    font-size: 14px;
    line-height: 20px;
    border: 1px solid #3F6EFC;
    border-radius: 8px 0 8px 0;
    padding: 0 10px;
    margin-left: 10px;
  }
}
.head-title{
  display: flex;
}
.forecast-logo{
  position: absolute;
  width: 110px;
  left: 15px;
  top: 15px;
  cursor: pointer;
}

.menu-wrap{
  position: relative;
  width: 100%;
  padding-left: 200px;
  margin: 0 auto;
  display: flex;
}

.forecast-logo img{
  width: 100%;
}
.header-portrait{
  display: flex;
  .pic{
    width: 32px;
    height: 32px;
    border-radius: 32px;
    margin-right: 10px;
    background-color: #f2f2f2;
    display: inline-block;
  }
  .tel{
    color: #fff;
  }
}

.menu{
  line-height: 60px;
  color: rgba(255, 255, 255, 1);
  cursor: pointer;
}

.menu span{
  margin: 0 20px;
  font-size: 18px;
}

.menu a{
  color: #fff;
}

.back{
  color: #fff;
  text-align: center;
  height: 30px;
  margin: 20px 15px;
  cursor: pointer;
}

.user{
  padding-top: 20px;
  margin-right: 20px;
  color: #fff;
  cursor: pointer;
  min-width: 90px;
}

.form{
  margin-top: 14px;
}

.form p{
    color: rgba(92, 121, 176, 1);
    padding-bottom: 6px;
}
.login-bar{
    height: 60px;
    line-height: 60px;
    cursor: pointer;
    padding: 0 20px;
    color: #fff;
    min-width: 60px;
}

.code-panel h4{
  color: #F86359;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
}

.code-panel .if{
  color: #212731;
  margin-bottom: 35px;
}

.code-bar p{
  margin-bottom: 8px;
  color: @wordColor1;
}
.forecast-topHead{
  a{
    font-size: 18px;
    color: #222;
    font-weight: bold;
    cursor: pointer;
  }
  span{
    font-size: 18px;
    color: #999;
    font-weight: bold;
  }
}
</style>
<style lang="less">
.el-dropdown-menu__item:hover .out a{
  color: #F86359;
}
.memberDialog .el-dialog__body{
    padding-top: 0;
}

.memberDialog .el-dialog__header{
    padding: 0;
    text-align: center;
    color: rgba(79, 94, 123, 1);
    border-bottom: 1px solid rgba(215, 229, 249, 1);
    padding: 12px 0;
    
}

.memberDialog .el-dialog__headerbtn{
    top: 13px;
    right: 13px;
}

.memberDialog .el-dialog__title{
    color: rgba(79, 94, 123, 1);
    font-size: 16px;
}

.bookDialog .el-dialog__body{
  padding: 0;
}

.bookDialog .el-dialog__header{
    padding: 0 0 0 12px;
    text-align: left;
    height: 40px;
    line-height: 40px;
    background: @mainColor;   
}

.bookDialog .el-dialog__title{
  color: #fff;
}

.word-pic{
  width: 30px;
  display: inline-block;
}

.word-pic img{
  width: 100%;
}

.bookDialog .el-dialog__headerbtn{
  top: 10px;
}

.bookDialog .el-dialog__headerbtn .el-dialog__close{
  color:#fff;
}

.el-collapse-item__wrap{
    width: 100%;
    border-bottom: none;
}
.el-collapse-item__content{
    padding: 0 12px;
}
.el-collapse-item__header{
    background: @headerColor !important;
    line-height: 35px;
    height: 35px;
    padding-left: 10px;
    color: @wordColor1;
    font-size: 16px;
    font-weight: normal;
}
.el-collapse{
    border-top: none !important;
}

.case-panel .el-button{
    padding: 8px 20px !important;
}

.el-collapse-item__arrow{
    line-height: 36px;
}

.radio-item .el-radio{
    color: @wordColor1;
    font-size: 16px;
}
.el-input-number{
    width: 150px;
}
.el-input-number .el-input .el-input__inner{
    height: 35px;
    line-height: 35px;
}
.el-input-number__decrease, .el-input-number__increase{
    width: 30px;
}
.tooltip-dark{
    width: 300px;
}
.narcotics-label{
  flex: 1;
  width: 0;
  display: inline-block;
  padding-right: 10px;
  color: @wordColor1;
  word-break: break-all;
  line-height: 22px;
  white-space: normal;

  &:last-child {
    margin-right: 0;
  }
}

.nav-select .el-select-dropdown__wrap{
    max-height: 500px;
}

.nav-select .el-select-dropdown__item{
  display: flex;
  align-items: flex-start;
  height: auto;
  margin-top: 10px;
  min-height: 40px;
}

.nav-select .el-select-dropdown__item.is-disabled{
    cursor: default;
}

.fixed-radio .el-radio__label{
    display: inline-block;
    width: 390px;
    font-size: 16px;
    color: @wordColor2;
}

.fixed-scrollBar{
    height: calc(100vh - 45px);
}
.group-item .el-checkbox__label{
    vertical-align: top;
    white-space: pre-line;
    padding-right: 10px;
    color: @wordColor1;
    font-size: 16px;
}
.group-item .el-checkbox__label span{
    font-weight: bold;
}
.group-item .el-checkbox__input{
    margin-top: 2px;
}


.tipDialog .el-dialog__header{
    padding: 10px;
    background: @mainColor;
}

.tipCustomDialog .el-dialog__header{
    border-radius: 3px 3px 0 0;
}

.tipDialog .el-dialog__title{
    color: #fff;
    font-size: 14px;
}

.tipDialog .el-dialog__headerbtn{
    top: 12px;
}

.tipDialog .el-dialog__body{
    padding: 20px 0 0 0;
}

.tipCustomDialog{
    border-radius: 3px;
}

.tipCustomDialog .el-dialog__headerbtn .el-dialog__close{
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/forecast/Layout.vue